import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"



export default /*#__PURE__*/_defineComponent({
  __name: 'btn',
  props: {
	lable: {
		default: '',
	},
	color: {
		default: 'green',
	},
	size: {
		default: 'large',
	},
	loading: {
		type: Boolean,
		default: () => {
			return false
		},
	},
},
  setup(__props) {

const props = __props

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createBlock(_component_a_button, {
    class: _normalizeClass({
			green: props.color === 'green',
			yellow: props.color === 'yellow',
			gray: props.color === 'gray',
		}),
    type: "primary",
    size: props.size,
    loading: __props.loading
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(props.lable), 1)
    ]),
    _: 1
  }, 8, ["class", "size", "loading"]))
}
}

})